import {makeStyles} from '@material-ui/core'


export const useStyles = makeStyles({
  
   
    heading:{
        width:"75%",
        height:"125%",
        objectFit:"cover",
        position:"absolute",
        zIndex:"-1",
        
    },
    mainDiv:{
        // marginTop:"5%",
        marginBottom:"2%",
        position:"relative",
        backgroundColor:"#D9D9D9",
        width:"100%",
        borderRadius: ".5vw",

    },
    headingText:{
        color:"black",
        fontSize:"2.5vw",
        marginLeft:"7%",
        pointerEvents:'none',
        fontWeight:350
    },
    linkless : {
        color: "black",
        textDecorationStyle:"none",
        textDecoration: "none"
    },
    imageBox :{
        
            position:"relative",
            width:"100%",
            zIndex:"1"
    },

    image:{
        padding: "5% 15% 5% 15%",
        width:"60%", 
        height:"60%",
        display:"block",
        objectFit:"cover",
        userDrag:"none",
        pointerEvents:'none',
        borderRadius:"25%"
    },
    a:{

    }
    
})

